export default function faqAccordion(root = document) {
  const accordions = root.querySelectorAll(".js-accordion");
  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    // 再初期化時の重複バインド防止
    if (accordion.dataset.accordionInitialized === "true") return;
    accordion.dataset.accordionInitialized = "true";

    accordion.addEventListener("click", (event) => {
      const accordionItem = event.target.closest(".js-accordion-trigger");
      if (!accordionItem || !accordion.contains(accordionItem)) return;

      const accordionContent =
        accordionItem.querySelector(".js-accordion-content") ||
        accordionItem.nextElementSibling;
      if (!accordionContent) return;

      const isOpen = accordionItem.classList.toggle("is-open");
      accordionContent.style.display = isOpen ? "block" : "none";
    });
  });
}
